import React, { useCallback } from 'react';
import DataTable from 'react-data-table-component';
import { useTranslation } from 'react-i18next';

function NoDataMessage({ t }) {
  return (
    <div className="textEmptyData">
      {t('wla.status.not_found')}
    </div>
  );
}

function Table({
  filter,
  data,
  columns,
  isFixHeader,
  noTablehead,
  customStyles,
  pagination,
  paginationServer,
  noHeader,
  subHeader,
  conditionalRowStyles,
  fixedHeaderScrollHeight,
  height,
  totalRows,
  onFetchData,
  page,
  perPage, // default limit
  progressComponent,
  progressPending,
}) {
  const { t } = useTranslation();
  const customFalse = {
    table: {
      style: {
        height: height || '100%',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          width: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#444444',
        },
        '&::-webkit-scrollbar-track': {
          WebkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.1)',
          borderRadius: '10px',
        },
      },
    },
    headCells: {
      style: {
        fontFamily: 'sans-serif',
        justifyContent: 'space-between !important',
        whiteSpace: 'normal',
      },
    },
    subHeader: {
      style: {
        display: 'none',
      },
    },
  };

  const FilterComponent = useCallback(() => {
    switch (filter) {
      case 'tree_view':
        return (
          <div className="d-flex flex-row justify-content-between w-100">
            <div className="d-flex flex-row" style={{ columnGap: '10px' }}>
              <div className="obj-item">test Table</div>
              <div className="obj-item" />
            </div>
          </div>
        );

      default:
        return null;
    }
  }, [data, filter]);

  const paginationOptions = {
    rowsPerPageText: t('general.label_pagination_1'),
    rangeSeparatorText: t('general.label_pagination_2'),
  };

  const subHeaderComponentMemo = React.useMemo(
    () => <FilterComponent />,
    [data],
  );

  return (
    <DataTable
      columns={columns}
      data={data}
      subHeader={subHeader}
      pagination={pagination}
      paginationServer={paginationServer}
      paginationTotalRows={totalRows}
      paginationPerPage={perPage}
      paginationDefaultPage={page}
      onChangePage={(newPage) => {
        if (onFetchData) {
          onFetchData(newPage, perPage);
        }
      }}
      onChangeRowsPerPage={(newPerPage, newPage) => {
        if (onFetchData) {
          onFetchData(newPage, newPerPage);
        }
      }}
      fixedHeader={!!isFixHeader}
      noTableHead={noTablehead}
      subHeaderAlign="left"
      subHeaderComponent={subHeaderComponentMemo}
      customStyles={customStyles || customFalse}
      noHeader={noHeader}
      conditionalRowStyles={conditionalRowStyles}
      paginationComponentOptions={paginationOptions}
      noDataComponent={<NoDataMessage t={t} />}
      fixedHeaderScrollHeight={fixedHeaderScrollHeight}
      progressPending={progressPending}
      progressComponent={progressComponent}
    />
  );
}

export default Table;
